import {KoAPI} from "packages";
import { configs } from 'configuration';
const version = configs().API_VERSION;
export const DashboardAPI = {
  getRecentTicket(workspaceId, query) {
    return KoAPI.get(`/api/${version}/taskplanner/ticket/recent`, { query: { ...query }, header: { "workspace": workspaceId } });
  },

  getEstimatedVsActualTime(workspaceId, query) {
    return KoAPI.get(`/api/${version}/taskplanner/development/dashboard/actual/time`, { query: { ...query }, header: { "workspace": workspaceId } });
  },

  getLeaveChart(workspaceId, query) {
    return KoAPI.get(`/api/${version}/taskplanner/development/dashboard/leavechart`, { query: { ...query }, header: { "workspace": workspaceId } });
  },

  getUserWorkload(workspaceId, query) {
    return KoAPI.get(`/api/${version}/taskplanner/development/dashboard/workload`, { query: { ...query }, header: { "workspace": workspaceId } });
  },

  getTeamsCount(workspaceId, query) {
    return KoAPI.get(`/api/${version}/taskplanner/development/dashboard/teams/count`, { query: { ...query }, header: { "workspace": workspaceId } });
  },

  getTotalTasks(workspaceId, query) {
    return KoAPI.get(`/api/${version}/taskplanner/development/dashboard/totaltask`, { query: { ...query }, header: { "workspace": workspaceId } });
  },

  getOverdueTasks(workspaceId, query) {
    return KoAPI.get(`/api/${version}/taskplanner/development/dashboard/overdue`, { query: { ...query }, header: { "workspace": workspaceId } });
  },

  getTotalDocuments(workspaceId, query) {
    return KoAPI.get(`/api/${version}/taskplanner/development/dashboard/count/docs`, { query: { ...query }, header: { "workspace": workspaceId } });
  },
  getPriorityGraph: (workspaceId, query) =>
    KoAPI.get(`/api/${version}/taskplanner/development/dashboard/priority`, {
      query,
      header: { workspace: workspaceId }
    }),

  getIssueTypeGraph: (workspaceId, query) =>
    KoAPI.get(`/api/${version}/taskplanner/development/dashboard/issuetype`, {
      query,
      header: { workspace: workspaceId }
    }),

  getWorkflowStatus: (workspaceId, query) =>
    KoAPI.get(`/api/${version}/taskplanner/development/dashboard/workstatus`, {
      query,
      header: { workspace: workspaceId }
    }),

  getUserStatusBreakdown: (workspaceId, query) =>
    KoAPI.get(`/api/${version}/taskplanner/development/dashboard/userstatus`, {
      query,
      header: { workspace: workspaceId }
    }),

  getVelocityOverview: (workspaceId, query) =>
    KoAPI.get(`/api/${version}/taskplanner/development/dashboard/daystatus`, {
      query,
      header: { workspace: workspaceId }
    }),

  getBillableData: (workspaceId, query) =>
    KoAPI.get(`/api/${version}/taskplanner/development/dashboard/billable`, {
      query,
      header: { workspace: workspaceId }
    }),

  getTechDebtData: (workspaceId, query) =>
    KoAPI.get(`/api/${version}/taskplanner/development/dashboard/added/resolved`, {
      query,
      header: { workspace: workspaceId }
    }),

  getLoggedTime: (workspaceId, query) =>
    KoAPI.get(`/api/${version}/taskplanner/development/dashboard/time/logged`, {
      query,
      header: { workspace: workspaceId }
    }),

  getPullRequest: (workspaceId, query) =>
    KoAPI.get(`/api/${version}/taskplanner/development/dashboard/prcount`, {
      query,
      header: { workspace: workspaceId }
    }),

  getBurndown: (workspaceId, query) =>
    KoAPI.get(`/api/${version}/taskplanner/development/dashboard/burndown`, {
      query,
      header: { workspace: workspaceId }
    }),

  getDeliveryTimeline: (workspaceId, query) =>
    KoAPI.get(`/api/${version}/taskplanner/development/dashboard/sprint/timeline`, {
      query,
      header: { workspace: workspaceId }
    }),
  getDaysRemaining(id, workspaceId) {
    return KoAPI.get(`/api/${version}/taskplanner/dashboard/sprint/${id}`, { header: { "workspace": workspaceId } });
  }
};